exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "avatar-app{display:inline-block}avatar-app .avatar-container{background-color:#0072c9;border-radius:100%;height:40px;width:40px;line-height:40px;display:inline-block}avatar-app .avatar-container.size-big{height:80px;width:80px;line-height:80px}avatar-app .avatar-container.size-big .initials-container span{font-size:35px}avatar-app .avatar-container.size-medium{height:40px;width:40px;line-height:40px}avatar-app .avatar-container.size-medium .initials-container span{font-size:15px}avatar-app .avatar-container.with-picture{background-color:transparent}avatar-app .avatar-container .initials-container{text-align:center}avatar-app .avatar-container .initials-container::selection{background-color:transparent}avatar-app .avatar-container img{object-fit:cover;font-family:object-fit\\: cover;border-radius:100%;height:100%;width:100%}avatar-app .avatar-container span{color:#f9f9f9;font-family:Stag Sans;font-size:16px;font-weight:500}avatar-app .avatar-container span::selection{background-color:transparent}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/components/avatar/avatar.scss
// module id = 703
// module chunks = 0